import { formatAppDate, formatAppTime } from "./appTimeFormat";

export const formatFixtureTime = (timeString) => formatAppTime(timeString);

export const formatFixtureDate = (timeString) => {
  const date = new Date(timeString);
  if (Number.isNaN(date.getTime())) return "—";
  return formatAppDate(date);
};
